import Layout from '@/layout';

export default [
  {
    path: '/studio',
    name: 'Studio',
    redirect: '/studio/creatorHome',
    component: Layout,
    meta: {
      title: '工作室',
      icon: 'icon-studio',
      activePath: 'creatorHome',
    },
    children: [
      {
        path: 'creatorHome',
        name: 'creatorHome',
        redirect: '/studio/creatorHome/creator',
        component: () => import('@/views/studio/creatorHome.vue'),
        meta: {
          title: '工作室创建',
          activePath: 'creatorHome',
        },
        children: [
          {
            path: 'creator',
            name: 'creator',
            component: () => import('@/views/studio/components/creator.vue'),
            meta: {
              title: '工作室创建',
              activePath: 'creatorHome',
            },
          },
          {
            path: 'form',
            name: 'creatorForm',
            component: () =>
              import('@/views/studio/components/creatorForm.vue'),
            meta: {
              title: '创建工作室',
              activePath: 'creatorHome',
            },
          },
        ],
      },
    ],
  },
];
